import type { FaireProductEntity } from "../../entity_types/product";

export const p_7wu3lcnn2o: FaireProductEntity = {
  token: "p_7wu3lcnn2o",
  type: "product",
  name: "Franks A Lot Thank You Card",
  brandToken: "b_d9d4f3d7",
  brandName: "Ladyfingers Letterpress",
  imageUrl:
    "https://cdn.faire.com/fastly/19a73dbd0068be17049f6abd8f4eef4a6d400c0a748f6e94cd59b31eee3fd4e6.jpeg",
  galleryImageUrls: [],
  priceDollars: 3,
  description:
    'When one "Frank You" will not do, this card has, like, six. Just make sure it\'s got an internal temperature of at least 160? before serving.',
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:43.244Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
